import script from "./accounts.vue?vue&type=script&setup=true&lang=js"
export * from "./accounts.vue?vue&type=script&setup=true&lang=js"

import "./accounts.vue?vue&type=style&index=0&id=5d80a42e&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d80a42e"]])

export default __exports__